import React from "react";

export default function BankStatement() {
  return <div>working</div>;
}
